import { Row, Col, Card, Container } from "react-bootstrap";

export const ForYou = (homePageData) => {
  return (
    <section className="foryou" id="foryou">
      <Container>
        {/* Title Section */}
        <Row className="text-center mb-5">
          {homePageData.homePageData.forYou?.title?.visible && (
            <h2>{homePageData.homePageData.forYou.title.text}</h2>
          )}
        </Row>

        {/* Description Section */}
        <Row className="mb-5">
          {homePageData.homePageData.forYou?.visible && (
            <div
              dangerouslySetInnerHTML={{
                __html: homePageData.homePageData.forYou.description.text,
              }}
            ></div>
          )}
        </Row>

        {/* Cards Section */}
        <Row className="align-items-center">
          {homePageData?.homePageData?.forYou?.cards?.map((card, index) => {
            if (card?.visible) {
              return (
                <Col
                  xs={12}
                  md={12}
                  lg={6}
                  xl={4}
                  xxl={4}
                  key={`cardColumn${index}`}
                >
                  <Card key={`card${index}`} className="mb-4">
                    <Card.Body className="text-center">
                      {/* Card Title */}
                      {card.title && <h4>{card.title}</h4>}

                      {/* Card Icon */}
                      {card.icon && (
                        <i
                          className={`bi ${card.icon}`}
                          style={{
                            color: card.iconColor || "#000",
                            fontSize: "140px",
                          }}
                        ></i>
                      )}

                      {/* Card Description */}
                      {card.description && <p>{card.description}</p>}
                    </Card.Body>
                  </Card>
                </Col>
              );
            }
            return null; // Do not render if the card is not visible
          })}
        </Row>
      </Container>
    </section>
  );
};